import { useParams } from "react-router-dom";

export default function MenuSettings() {
  const { menuId } = useParams();

  return (
    <div>
      <h1>تنظیمات منو</h1>
      <p>آیدی منو: {menuId}</p>
    </div>
  );
}
